<!--- TOP SECTION -->
<div class="top-section" [formGroup]="form">
  <ion-row>
    <ion-col size="5">
      <app-form-select
        [formControlName]="'customerScanType'"
        [label]="CONSTANTS.CUSTOMER_SCAN_TYPE_LABEL"
        [options]="CUSTOMER_SCAN_TYPES"
        [hasTooltip]="true"
        [tooltipText]="CONSTANTS.SCAN_TYPE_HELPER_TEXT"
      ></app-form-select>
    </ion-col>
    <ion-col size="4">
      <app-form-select
        [formControlName]="'customerValidateType'"
        [label]="CONSTANTS.CUSTOMER_VALIDATION_TYPE_LABEL"
        [options]="CUSTOMER_VALIDATION_TYPES"
        [hasTooltip]="true"
        [tooltipText]="CONSTANTS.VALIDATION_TYPE_HELPER_TEXT"
      ></app-form-select>
    </ion-col>
    <ion-col size="3">
      <app-form-select
        [formControlName]="'customerType'"
        [label]="CONSTANTS.CUSTOMER_TYPE_LABEL"
        [options]="CUSTOMER_TYPES"
      ></app-form-select>
    </ion-col>
  </ion-row>
  <ion-row>
    <!-- DATA RETENTION -->
    <ion-col size="2" class="data-retention-container">
      <div class="form-group">
        <label class="form-label">
          {{ CONSTANTS.DATA_RETENTION }}
          <span class="required-field"> * </span></label
        >
        <ion-item class="custom-number-wrapper" lines="none">
          <ion-input
            formControlName="dataRetentionDays"
            type="number"
            class="form-control"
            min="1"
            max="7"
          ></ion-input>
        </ion-item>
      </div>
    </ion-col>
    <!--------------->
    <!--LOCATION TYPE-->
    <ion-col size="2">
      <div class="location-type-container">
        <app-form-text-field
          [labelText]="CONSTANTS.SITE_TYPE"
          [maxLength]="2"
          [form]="form"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [control]="'siteType'"
          [hasRequiredSign]="true"
          [autoCapitalizeCharacters]="true"
          [placeholderText]="CONSTANTS.SITE_TYPE_PLACEHOLDER"
        ></app-form-text-field>
      </div>
    </ion-col>
    <!--------------->
    <!--SMART DATA THRESHOLD-->
    @if (canSeeThresholds) {
      <ion-col size="2.5" class="data-retention-container">
        <app-form-text-field
          [form]="form"
          [control]="'smartDataThreshold'"
          [labelText]="CONSTANTS.SMART_OPS_THRESHOLD"
          [regexType]="SpecialCharacters.NUMBER_ONLY"
          [pasteRegexType]="'numeric'"
        />
      </ion-col>
    }
    <!--------------->
    <!--WEEKEND OPS THRESHOLD-->
    @if (canSeeThresholds) {
      <ion-col size="2.5" class="data-retention-container">
        <app-form-text-field
          [form]="form"
          [control]="'weekendOpsThreshold'"
          [labelText]="CONSTANTS.WEEKEND_OPS_THRESHOLD"
          [regexType]="SpecialCharacters.NUMBER_ONLY"
          [pasteRegexType]="'numeric'"
        />
      </ion-col>
    }
    <!--------------->
    <!--FORCE AGENT SCAN-->
    <ion-col size="2" class="force-agent-scan">
      <app-form-checkbox
        formControlName="forceAgentScan"
        [label]="CONSTANTS.FORCE_AGENT_SCAN"
      >
      </app-form-checkbox>
    </ion-col>
    <!--------------->
  </ion-row>
</div>
<!--------------->
